import "./SalesOrderProcess.css"
import { createPortal } from 'react-dom';

import { regUses, useRcds, useTpl, getRcds, addTblRcds, randomUUID, getDate} from "../../axios_with_token";
import { useListOfOrdersOfStatus } from "../../input_types/Tbl/Tbl";
import { useLayoutEffect, useRef, useState } from "react";
import { useDialog, useRcdEditDialog } from "../../input_types/Dialog/Dialog";

// import WWAccordion from "../../components/WWAccordion/WWAccordion";
// import WWTabs from "../../components/WWTabs/WWTabs";


const nodes = [
    {
        name: 'all',
        caption: 'all orders'
    },
    {
        name: 'check_receivable',
        caption: 'check receivable'
    },
    {
        name: 'dispatch',
        caption: 'dispatch'
    },
    {
        name: 'deliver',
        caption: 'deliver'
    },
    {
        name: 'invoice',
        caption: 'issue invoice'
    },
    {
        name: 'collect_money',
        caption: 'collect money'
    },
    {
        name: 'review_and_close',
        caption: 'review and close'
    }
];

export function SalesOrderPhaseSelector({activeNode, setActiveNode, resetPage,
    openEditOrderDialog, setOrderRcdId, setOrderRcdDefault
}){
    
    return <div className="pipeline-node-list row rounded mb-1">
        <div 
            className={`bg-primary text-light pipeline-node rounded col m-1 pt-1 pb-3`}
            onClick={evt=>{
                setOrderRcdId(0);
                setOrderRcdDefault({
                    status: 'verify',
                    date: getDate(),
                });
                openEditOrderDialog();
            }}
        >new order</div>

        {nodes.map(node=><div 
            className={`${activeNode==node.name?'active ':''}pipeline-node rounded col m-1 pt-1 pb-3`}
            key={node.name}
            value={node.name}
            onClick={evt=>{
                setActiveNode(evt.target.getAttribute('value'));
                // reset page to 1
                resetPage();
            }}
        >{node.caption||node.name}</div>)}
    </div>;
}

export function useWarehouseSelector({warehouseId, setWarehouseId, resetPage}){
    const {regUse, DefaultResponse} = regUses();
    const {data:rcdsWarehouse} = regUse(useRcds("addresses", 0, 9999, [{
        __commonFlds: 'purposes',
        __commonFilters: 'warehouse'
    }]));
    const Comp = ()=><DefaultResponse>
            <WarehouseSelector
                warehouseId = {warehouseId}
                setWarehouseId = {setWarehouseId}
                resetPage = {resetPage}
                rcdsWarehouse = {rcdsWarehouse}
            ></WarehouseSelector>
        </DefaultResponse>;
    return {
        WarehouseSelector:Comp,
        rcdsWarehouse
    };
}

export function WarehouseSelector({warehouseId, setWarehouseId, resetPage, rcdsWarehouse}){

    return <div className="input-group">
            <span className="input-group-text">warehouse</span>
            <select
                className="form-control form-control-sm"
                defaultValue={warehouseId}
                onChange={evt=>{
                    setWarehouseId(evt.target.value);
                    // setPosFilter([]);
                }}
                role="addr"
                // ref={refAddr}
            >
                <option
                    key={0}
                    value={0}
                ></option>
                {((rcdsWarehouse||{}).rcds||[]).map((rcd, idx)=><option
                    key={rcd.__id}
                    value={rcd.__id}
                >
                    {rcd.name}
                </option>)}
            </select>
            <button className="btn btn-sm btn-outline-secondary" type="button"
                onClick={evt=>{
                    // openDlgWarehouseInfoDlg();
                }}
            >i</button>
            <button className="btn btn-sm btn-outline-secondary" type="button"
                onClick={evt=>{
                    setWarehouseId(0);
                }}
            >X</button>
        </div>;
}

// function SelectAddressDlg({openDlg, setDlgStatus}){
//     const {Dialog:SelectAddressDlg, openDialog:openSelectAddressDlg} = useDialog({
//             dlgTitle: 'select address'
//     });
//     // useEffect(_=>{
//     //     openDlg&&openSelectAddressDlg();

//     // }, [openDlg])
//     // return openDlg&&createPortal(
//     //         <div
//     //             // className="dialog-overlay" onClick={clickOutsideToHide?onClose:undefined}
//     //             // ref={refDlg} 
//     //         >
//     //             <h1>aaaaa</h1>
//     //         </div>,
//     //     document.getElementById('dialog-root'));

//     return openDlg&&createPortal(
//                         <div
//                             className="dialog-overlay" onClick={evt=>{}}
//                             style={{zIndex: '99999999999'}}
//                             // ref={refDlg} 
//                         >
//                             <div className='dialog-container'>
//                                 <div className="dialog-content" >
//                                     <h1>aaaaa</h1>
//                                     <button type="button" onClick={evt=>setDlgStatus(false)}>x</button>
                                    
//                                 </div>
//                             </div>
//                         </div>,
//                     document.getElementById('popup-root'));
// }

export default function SalesOrderProcess({}){
    function fillAddress(form, fldName, rcdAdress, noRefresh){
        rcdAdress = rcdAdress || {};
        if(form){
            form.setValue(fldName + '_address1',rcdAdress['address1']);
            form.setValue(fldName + '_address2',rcdAdress['address2']);
            form.setValue(fldName + '_city',rcdAdress['city']);
            form.setValue(fldName + '_province',rcdAdress['province']);
            form.setValue(fldName + '_country',rcdAdress['country']);
            form.setValue(fldName + '_zip',rcdAdress['zip']);

            (!noRefresh)&&setCurValues(form.getValues());
        }
    }

    const [warehouseId, setWarehouseId] = useState(0);
    const {WarehouseSelector, rcdsWarehouse} = useWarehouseSelector({warehouseId,setWarehouseId});

    const refData = useRef({
        curForm: false
    });
    const tblName = 'orders';
    const [resetPageId, setResetPageId] = useState(0);
    const resetPage = _=> setResetPageId(prevId => prevId + 1);
    
    const [curValues, setCurValues] = useState(false);
    const [listFlds, setListFlds] = useState(`sn,date,buyer__xpd__,status,attachment`);

    
    const {regUse, DefaultResponse} = regUses();
    const [activeNode, setActiveNode] = useState(nodes[0].name);
    const getFilter = _=>{
        const filter = {};

        return filter;
    }

    // edit dlg
    const {data:rcdTpl} = useTpl('orderTpl')
    const editDlg = useRcdEditDialog({
        curValues,
        tblName,
        rcdId:null,
        onSaved: _=>{
            invalidateSalesOrdersList();
        },
        tpl: document.documentElement.clientWidth > 769 ? <div dangerouslySetInnerHTML={{ __html: (rcdTpl||{}).content }}></div> : false,

        inputs: {
            'buyer-clear-address': function CLR({fldName, form, fldDef}){
                return <button
                        type="button"
                        title="fill address"
                        className="btn btn-primary"
                        onClick={evt=>{
                            const form = refData.current.curForm;
                            if(form){
                                const rcdAdress={};
                                console.log('clear address', form);
                                form.setValue('buyer_address1',rcdAdress['address1']);
                                form.setValue('buyer_address2',rcdAdress['address2']);
                                form.setValue('buyer_city',rcdAdress['city']);
                                form.setValue('buyer_province',rcdAdress['province']);
                                form.setValue('buyer_country',rcdAdress['country']);
                                form.setValue('buyer_zip',rcdAdress['zip']);

                            }
                        }}
                    >C</button>;
            },
            'buyer_billing-clear-address': function CLR({fldName, form, fldDef}){
                return <button
                        type="button"
                        title="fill address"
                        className="btn btn-primary"
                        onClick={evt=>{
                            const form = refData.current.curForm;
                            if(form){
                                const rcdAdress={};
                                form.setValue('buyer_billing_address1',rcdAdress['address1']);
                                form.setValue('buyer_billing_address2',rcdAdress['address2']);
                                form.setValue('buyer_billing_city',rcdAdress['city']);
                                form.setValue('buyer_billing_province',rcdAdress['province']);
                                form.setValue('buyer_billing_country',rcdAdress['country']);
                                form.setValue('buyer_billing_zip',rcdAdress['zip']);

                            }
                        }}
                    >C</button>;
            },
            '_buyer-fill-address': function BFA({fldName, form, fldDef}){
                const {regUse, DefaultResponse} = regUses();
                const [entityId, setEntityId] = useState(0);
                // const entityId = (form.getValues() || {})['buyer'];
                const {data:rcdsAddress} = regUse(useRcds('addresses',0,9999,{
                    __filterFlds: {
                        entity: `^${entityId}$`
                    }
                }));
                const rcdAdress = ((rcdsAddress||{}).rcds||[])[0]||{};

                // useEffect(_=>{
                    // form.setValues({
                    //     'buyer_address1': rcdAdress['address1'],
                    //     'province': rcdAdress['province'],
                    //     'country': rcdAdress['country']
                    // });
                    // form.setValue('buyer_address1',rcdAdress['address1']);
                    // form.setValue('buyer_address2',rcdAdress['address2']);
                    // form.setValue('buyer_city',rcdAdress['city']);
                    // form.setValue('buyer_province',rcdAdress['province']);
                    // form.setValue('buyer_country',rcdAdress['country']);
                    // form.setValue('buyer_zip',rcdAdress['zip']);
                    // console.log(entityId, rcdAdress);
                // }, [entityId])

                return <DefaultResponse>
                    {/* <div>{JSON.stringify(rcdsAddress)}</div> */}
                    <button
                        type="button"
                        title="fill address"
                        className="btn btn-primary"
                        onClick={evt=>{
                            // alert((form.getValues() || {})['buyer']);
                            // form.setValue('buyer_address1','aaaaaaa');
                            // setR(r+1);
                            setEntityId((form.getValues() || {})['buyer']);
                        }}
                    >A</button> 
                </DefaultResponse>;
            },
            'buyer_billing-to-buyer': function CLR({fldName, form, fldDef}){
                return <button
                        type="button"
                        title="fill address"
                        className="btn btn-primary"
                        onClick={evt=>{
                            const form = refData.current.curForm;
                            if(form){
                                const rcdAdress = form.getValues();
                                console.log('buyer set to ', rcdAdress['buyer_billing']);
                                form.setValue('buyer', rcdAdress['buyer_billing']);
                                form.setValue('buyer_address1',rcdAdress['buyer_billing_address1']);
                                form.setValue('buyer_address2',rcdAdress['buye_billing_address2']);
                                form.setValue('buyer_city',rcdAdress['buyer_billing_city']);
                                form.setValue('buyer_province',rcdAdress['buyer_billing_province']);
                                form.setValue('buyer_country',rcdAdress['buyer_billing_country']);
                                form.setValue('buyer_zip',rcdAdress['buyer_billing_zip']);
                            }
                        }}
                    >&gt;</button>;
            },
            'buyer-to-buyer_billing': function CLR({fldName, form, fldDef}){
                return <button
                        type="button"
                        title="fill address"
                        className="btn btn-primary"
                        onClick={evt=>{
                            const form = refData.current.curForm;
                            if(form){
                                const rcdAdress = form.getValues();
                                console.log('buyer_billing set to ', rcdAdress['buyer']);
                                form.setValue('buyer_billing', rcdAdress['buyer']);
                                form.setValue('buyer_billing_address1',rcdAdress['buyer_address1']);
                                form.setValue('buyer_billing_address2',rcdAdress['buye_address2']);
                                form.setValue('buyer_billing_city',rcdAdress['buyer_city']);
                                form.setValue('buyer_billing_province',rcdAdress['buyer_province']);
                                form.setValue('buyer_billing_country',rcdAdress['buyer_country']);
                                form.setValue('buyer_billing_zip',rcdAdress['buyer_zip']);
                            }
                        }}
                    >&lt;</button>;
            },            
        }
    });
    const {
        // formId: editRcdFormId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog: openEditOrderDialog,
        closeDialog,
        handleConfirm,

        setTblName,
        setRcdId: setOrderRcdId,
        setRcdDefault: setOrderRcdDefault,
        getRcdDefault,

        invalidate:invalidateOrderRcd,

        Dialog: EditOrderDialog,
        refDlg: refEditOrderDlg,

        forms: formsEditOrderDlg
        
    } = editDlg;

    // rcd list
    const {
        invalidate: invalidateSalesOrdersList,
        setActiveRcdId,
        Component: SalesOrdersList,
        setListType
    } = regUse(useListOfOrdersOfStatus({
        // tblName: 'orders', 
        status: activeNode,
        page: 0,
        resetPageFlag: resetPageId,
        rcdsPerPage: 10, 
        filter: getFilter(),
        orderby: {
            flds: 'date,buyer__xpd__',
            reverse: true
        },

        reset: JSON.stringify(getFilter()),
        // showIndex: false, 
        // listFlds:listFldsIn, 
        listType:'list',
        dataFlds: '__id,skidId',
        listFlds,
        
        hidePagination: false,
        hideSearch: false,
        hideListTypeSelector: true,
        // CompList: ()=><h5>list item</h5>,
        hideID: true,

        onItemClick: ({tblName, rcdId, evt, rcd})=>{
            // console.log('{tblName, __id, evt}:', tblName, rcdId, evt, rcd);
            // setPosId(rcdId);
            // openDlgPosInfoDlg();
        },
        btns: {
            editOrder: (['all'].indexOf(activeNode)>=0)&&'stdEdit',
            delete: (['all'].indexOf(activeNode)>=0)&&'stdDelete',
            chkReceivable: ((['check_receivable']).indexOf(activeNode)>=0)&&function ChkReceivable({rcdId, setRcdActive, rcd}){
                const {DefaultResponse} = regUses();
                const {Dialog, openDialog} = useDialog({
                    dlgTitle: "check receivable"
                });
                return  <DefaultResponse>
                    <Dialog>
                        <button
                            type = "button"
                            className="btn btn-primary"
                            onClick={evt=>{
                                return addTblRcds(
                                    tblName,
                                    [{
                                        __id: rcdId,
                                        status: 'process'
                                    }]
                                ).then(r=>{
                                    invalidateSalesOrdersList();
                                    return r;
                                });
                            }}
                        >verify order #{rcd.sn} at {rcd.date} by {rcd.buyer__xpd__}</button>
                    </Dialog>
                <button type="button"
                    className="btn btn-sm btn-sm btn-primary"
                    onClick={evt=>{
                        openDialog();
                        // // evt.stopPropagation();
                        // // setTblName('poses');
                        // // [] for RcdEditDialog
                        // setPosId(rcdId);
                        // // [] for list
                        // cb&&cb();
                        // openDlgPosInfoDlg();
                        // openEditOrderDlg();
                        // setActiveRcdId(rcdId);
                        setRcdActive&&setRcdActive();
                    }}
                >verify</button></DefaultResponse>
            },
            dispatch: ((['dispatch']).indexOf(activeNode)>=0)&&function Dispatch({rcdId, setRcdActive, rcd}){
                const {DefaultResponse} = regUses();
                // const [dispatchData, setDispatchData] = useState({});
                const addrPartNames = 'attn,tel,email,address1,address2,city,province,country,zip';
                const refData = useRef({
                    requestDate:getDate(),
                    shipTo:(rcd=>{
                        const addrInfo = {
                            buyer: rcd.buyer
                        };
                        addrPartNames.split(',').forEach(addrPartName=>{
                            addrInfo[addrPartName] = rcd['buyer_'+addrPartName];
                        });

                        return addrInfo;
                    })(rcd),
                    dispatchData: {}
                });
                const [warehouseId, setWarehouseId] = useState(0);
                const {Dialog, openDialog, setBtns, setDlgTitle, closeDialog} = useDialog({
                    dlgTitle: "dispatch",
                });
                function RequestDeliver({}){
                    const {Dialog:DlgDistachConfirm, openDialog:openDlgDistachConfirm, closeDialog:closeDlgDistachConfirm} = useDialog({
                        dlgTitle: "dispatch confirm",
                        btns:[
                            'cancel',
                            ({})=>{
                                return <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={evt=>{
                                        // "requestItems":"[{\"pdtId\":\"62\",\"qty\":240,\"unit\":\"PC\"},{\"pdtId\":\"69\",\"qty\":240,\"unit\":\"PC\"},{\"pdtId\":\"78\",\"qty\":480,\"unit\":\"PC\"}]",
                                        const requestDlvs = Object.keys(refData.current.dispatchData).map(wId=>{
                                            const dlvData = refData.current.dispatchData[wId];
                                            const requestItems = (dlvData=>{
                                                return Object.values(dlvData).map(item=>{
                                                    return {
                                                        pdtId: item.pdtId,
                                                        qty: item.qty,
                                                        unit: item.unit
                                                    }
                                                })
                                            })(dlvData);
                                            return requestItems.length&&{
                                                warehouseId: wId,

                                                requestDate: refData.current.requestDate,

                                                to: refData.current.shipTo.buyer,
                                                to_address1: refData.current.shipTo.address1,
                                                to_address2: refData.current.shipTo.address2,
                                                to_city: refData.current.shipTo.city,
                                                to_country: refData.current.shipTo.country,
                                                to_province: refData.current.shipTo.province,
                                                to_zip: refData.current.shipTo.zip,

                                                requestItems: JSON.stringify(requestItems)


                                            }
                                        }).filter(a=>a);
                                        addTblRcds('deliveries', requestDlvs, {}).then(r=>{
                                            // Object.values(refData.current.dispatchDat).forEach(wDispatch=>)
                                            console.log(r);
                                            closeDialog();
                                            invalidateSalesOrdersList();
                                            // refresh list
                                        });

                                    }}
                                >confirm</button>
                            }
                        ]
                    });
                    function DistachConfirmContent({dispatchData}){
                        return <div>{Object.keys(dispatchData).map(wId=>{
                            const wDef = rcdsWarehouse.rcdsById[wId];
                            const wRequestDlv = dispatchData[wId];
                            const wRequestPdtIds = Object.keys(wRequestDlv);
                            const fldNames = 'pdtCaption,qty,unit'.split(',').filter(a=>a);
                            return (wRequestPdtIds.length>0)&&<div
                                className="container shadow-sm p-3 mb-5 bg-body rounded"
                                key={randomUUID()}
                            >
                                <table>
                                    <tbody className="table table-sm">
                                        <tr>
                                            <td className="fw-bold">deliver from:</td>
                                            <td>[ {wDef.name} ]</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">to:</td>
                                            <td></td>
                                        </tr>
                                        {
                                            'attn,tel,email'.split(',').map(addrPartName=><tr
                                                key={randomUUID()}
                                            ><td className="fw-bold">{addrPartName}</td><td>{refData.current.shipTo[addrPartName]}</td></tr>)
                                        }
                                        <tr>
                                            <td className="fw-bold">address:</td>
                                            <td>
                                                {
                                                    'address1,address2,city,province,country,zip'.split(',').map(addrPartName=>refData.current.shipTo[addrPartName] || '').filter(a=>a).join(',')
                                                }                                                
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>

                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            {fldNames.map(fldName=><th
                                                key={randomUUID()}
                                            >{fldName}</th>)}
                                         </tr>
                                    </thead>
                                    <tbody>
                                        {wRequestPdtIds.map((pdtId, idx)=>{
                                            const requestDlvItem = wRequestDlv[pdtId];
                                            return <tr
                                                key={`${wId}-${pdtId}`}
                                            >
                                                <td>{idx+1}</td>
                                                {fldNames.map(fldName=><td
                                                    key={randomUUID()}
                                                >{requestDlvItem[fldName]}</td>)}
                                            </tr>;
                                        })}
                                        
                                    </tbody>

                                </table>

                            </div>;
                        })}</div>;
                    }
                    return <>
                        <DlgDistachConfirm>
                            <DistachConfirmContent
                                dispatchData={refData.current.dispatchData}
                            ></DistachConfirmContent>
                        </DlgDistachConfirm>
                        <button type="button"
                            className="btn btn-primary"
                            onClick={evt=>{
                                openDlgDistachConfirm();
                            }}
                        >Request Deliver</button>;                        
                    </>

                }

                return  <DefaultResponse>
                    <Dialog>
                        <div className="container">
                            <div className="d-flex">
                                <div className="fw-bolder me-3">PO#:</div><div>{rcd.sn}</div>
                            </div>
                            <div className="d-flex">
                                <div className="fw-bolder me-3">date:</div><div>
                                    <input 
                                        className="form-control"
                                        type="date"
                                        defaultValue={getDate()}
                                        onChange={evt=>{
                                            // setQty(evt.target.value);
                                            refData.current.requestDate = evt.target.value;
                                        }}
                                    >
                                    </input>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="fw-bolder me-3">client:</div><div>{rcd.buyer__xpd__}</div>
                            </div>
                            <div className="d-flex">
                                <div className="fw-bolder me-3">ship to:</div>
                                <div>
                                    <table className="table table-sm"><tbody>
                                    {
                                        'attn,tel,email,address1,address2,city,province,country,zip'.split(',').map(addrItemName=><tr
                                            key={randomUUID()}
                                        >
                                            <td>{addrItemName}</td>
                                            <td>
                                                <input 
                                                    className="form-control"
                                                    type="text"
                                                    defaultValue={refData.current.shipTo[addrItemName]}
                                                    onChange={evt=>{
                                                        // setQty(evt.target.value);
                                                        refData.current.shipTo[addrItemName] = evt.target.value;
                                                    }}
                                                >
                                                </input>
                                            </td></tr>)
                                    }</tbody></table>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="fw-bolder me-3">note:</div>
                                <div><textarea
                                    className="form-control"
                                ></textarea></div>
                            </div>
                            {/* <div>{JSON.stringify(rcd)}</div> */}

                            <div className="d-flex">
                                <div className="fw-bolder me-3">items:</div>
                            </div>
                            <table className="table table-bordered border-secondary">
                                <thead>
                                    <tr>
                                        <th rowSpan={2}>No.</th>
                                        <th rowSpan={2}>product</th>
                                        <th rowSpan={2}>ordered</th>
                                        <th rowSpan={2}>dispatched</th>
                                        <th rowSpan={2}>need dispatch</th>
                                        <th colSpan={4}>dispatch</th>
                                    </tr>
                                    <tr>
                                        <th>warehouse</th>
                                        <th>quantity in stock</th>
                                        <th>dispatch amount</th>
                                        <th>unit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    {
                                        ((rcd.__orderedItems||[]).filter(orderedItem=>{
                                            const itemsStatusByPdtId = rcd.__itemsStatus;
                                            const pdtId = orderedItem.pdtId;
                                            const itemStatus = itemsStatusByPdtId[pdtId] || {};
                                            return itemStatus.notDispatched>0;
                                        }).concat(
                                            (rcd.__orderedItems||[]).filter(orderedItem=>{
                                                const itemsStatusByPdtId = rcd.__itemsStatus;
                                                const pdtId = orderedItem.pdtId;
                                                const itemStatus = itemsStatusByPdtId[pdtId] || {};
                                                return itemStatus.notDispatched<=0;
                                            })
                                        )).map((orderedItem,idx)=>{
                                            const itemsStatusByPdtId = rcd.__itemsStatus;
                                            const pdtId = orderedItem.pdtId;
                                            const itemStatus = itemsStatusByPdtId[pdtId] || {};
                                            
                                            function PdtItemDispatch({idx, pdtId, orderedItem,dispatchData}){
                                                function PdtItemDispatchWarehouse({warehouseDef, pdtId, pdtCaption, dispatchData, unit, setUnit, refresh}){
                                                    const [qty, setQty] = useState(0);
                                                    const warehouseId = warehouseDef.__id;
                                                    
                                                    // console.log('warehouseId && pdtId:', orderedItem);
                                                    function updateRefData(){
                                                        if(warehouseId && pdtId){
                                                            dispatchData[warehouseId] = dispatchData[warehouseId] || {};
                                                            const qtyVal = parseFloat(qty);
                                                            if(qtyVal && !isNaN(qtyVal)){
                                                                dispatchData[warehouseId][pdtId] = {
                                                                    pdtId,
                                                                    pdtCaption, 
                                                                    dir: -1,
                                                                    qty,
                                                                    warehouseId,
                                                                    unit
                                                                };    
                                                            }else{
                                                                delete dispatchData[warehouseId][pdtId];
                                                            }
                                                        }                                                        
                                                    }

                                                    const qty_in_stock = ((((itemStatus.qty||{}).pdtInWarehouse||{})[warehouseDef.__id]||{}).qty || 0) /  (unit=='DZ'?12:1);
                                                    return <tr>
                                                            <td>{warehouseDef.name}</td>
                                                            <td>{qty_in_stock} {unit}</td>
                                                            <td><input 
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={qty}
                                                                data-warehouse-id={warehouseDef.__id}
                                                                qty-in-stock={qty_in_stock}
                                                                old-qty={qty}
                                                                onChange={evt=>{
                                                                    const strInput = evt.target.value;
                                                                    const qty_in_stock = parseFloat(evt.target.getAttribute('qty-in-stock'));

                                                                    if(!/^\d*$/.test(strInput)){
                                                                        alert('not a number!');
                                                                        evt.target.value = evt.target.getAttribute('old-qty');
                                                                    }

                                                                    if(isNaN(qty_in_stock) || parseFloat(strInput) > qty_in_stock){
                                                                        alert('not enough inventory!');
                                                                        evt.target.value = evt.target.getAttribute('old-qty');
                                                                        return;
                                                                    }

                                                                    if(warehouseId && pdtId){
                                                                        dispatchData[warehouseId] = dispatchData[warehouseId] || {};
                                                                        const qtyVal = parseFloat(evt.target.value);
                                                                        if(qtyVal && !isNaN(qtyVal)){
                                                                            dispatchData[warehouseId][pdtId] = {
                                                                                pdtId,
                                                                                pdtCaption, 
                                                                                dir: -1,
                                                                                qty:qtyVal,
                                                                                warehouseId,
                                                                                unit
                                                                            };
                                                                            console.log('qtyVal:', qtyVal);
                                                                            setQty(qtyVal);
                                                                            refresh();
                                                                        }else{
                                                                            delete dispatchData[warehouseId][pdtId];
                                                                        }
                                                                    }

                                                                    // setQty(evt.target.value);

                                                                    // updateRefData();
                                                                    // setTimeout(() => {
                                                                    //     refresh();
                                                                        
                                                                    // }, 10);
                                                                }}
                                                                disabled={itemStatus.notDispatched<=0}></input></td>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    disabled={itemStatus.notDispatched<=0}
                                                                    defaultValue={unit}
                                                                    title={unit}
                                                                    onChange={evt=>{
                                                                        setUnit(evt.target.value);

                                                                        updateRefData();
                                                                        setTimeout(() => {
                                                                            refresh();
                                                                            
                                                                        }, 10);
                                                                    }}
                                                                >
                                                                    <option value="PC">piece</option>
                                                                    <option value="DZ">dozen</option>
                                                                </select>
                                                            </td>

                                                        </tr>
                                                }

                                                function PdtItemDispatchWarehouses({rcdsW, pdtId, pdtCaption, dispatchData, unit, setUnit}){
                                                    const totalDispatched = {};
                                                    const [refreshId, setRefreshId] = useState(0);
                                                    const refresh = _=>setRefreshId(refreshId+1);
                                                    Object.keys(refData.current.dispatchData).forEach(wId=>{
                                                        const wInfo = refData.current.dispatchData[wId];
                                                        console.log('wInfo:', wInfo);
                                                        Object.keys(wInfo).forEach(pdtId=>{
                                                            totalDispatched[pdtId] = totalDispatched[pdtId] || 0 + parseFloat(wInfo[pdtId].qty);
                                                        })
                                                    });
                                                    
                                                    return <>
                                                        {
                                                            rcdsW.map(rcdW=><PdtItemDispatchWarehouse
                                                                key={rcdW.__id||Math.random()}
                                                                pdtId={pdtId}
                                                                pdtCaption={pdtCaption}
                                                                warehouseDef={rcdW}
                                                                orderedItem = {orderedItem}
                                                                dispatchData = {dispatchData}

                                                                unit = {unit}
                                                                setUnit = {setUnit}

                                                                refresh={refresh}
                                                            ></PdtItemDispatchWarehouse>)
                                                        }
                                                        <tr>
                                                            <td>total</td>
                                                            <td>{(((itemsStatusByPdtId[pdtId]||{}).qty||{}).qty || 0) / (unit=='DZ'?12:1)} {unit}</td>
                                                            <td><span className={
                                                                parseFloat(totalDispatched[pdtId] || 0) - parseFloat(qtyNeedDispatch) == 0? 'text-success':'text-warning'
                                                            }>{totalDispatched[pdtId] || 0}</span> / {qtyNeedDispatch} {unit}</td>
                                                            <td>{unit}</td>

                                                        </tr>
                                                    </>
                                                }


                                                const [unit, setUnit] = useState(orderedItem.unit);

                                                const rcdsW = (rcdsWarehouse||{}).rcds||[];
                                                const cntW = rcdsW.length + 1;

                                                const pdtCaption = (itemStatus=>{
                                                    const [sn, name, brandAbbr]= itemStatus.pdtName.split(',');
                                                    return `[ ${sn} ] ${name}-${brandAbbr}`;
                                                })(itemStatus);

                                                const qtyNeedDispatch = itemStatus.notDispatched / (unit=='DZ'?12:1);
                                                return <>
                                                    <tr
                                                        className={itemStatus.notDispatched>0?'':'table-active disabled'}
                                                    >
                                                        <td rowSpan={cntW+1}>{idx+1}</td>
                                                        <td rowSpan={cntW+1}>{pdtCaption}</td>
                                                        {/* [] no need to divide by unit here, since orderedItem.qty is raw and aligned with unit */}
                                                        <td rowSpan={cntW+1}>{itemStatus.ordered / (unit=='DZ'?12:1)} {unit} {(itemStatus.ordered==orderedItem.qty*(orderedItem.unit=='DZ'?12:1))?'':<span>error: order qty not same!</span>}</td>
                                                        <td rowSpan={cntW+1}>{(itemStatus.ordered-itemStatus.notDispatched) / (unit=='DZ'?12:1)}  {unit}</td>
                                                        {/* <td>{(itemStatus.ordered-itemStatus.notDelivered)/(unit=='DZ'?12:1)}  {unit}</td> */}
                                                        <td rowSpan={cntW+1}>{qtyNeedDispatch} {unit}</td>
                                                    </tr>
                                                    <PdtItemDispatchWarehouses
                                                        pdtId={pdtId}
                                                        pdtCaption={pdtCaption}
                                                        rcdsW={rcdsW}
                                                        // warehouseDef={rcdW}
                                                        orderedItem = {orderedItem}
                                                        dispatchData = {dispatchData}

                                                        unit = {unit}
                                                        setUnit = {setUnit}
                                                    ></PdtItemDispatchWarehouses>
                                                </>;
                                            }
                                            
                                            return <PdtItemDispatch
                                                key={`pdt-${orderedItem.pdtId}`}
                                                idx={idx}
                                                pdtId={pdtId}
                                                orderedItem={orderedItem}
                                                // pdtId={pdtId}
                                                dispatchData={refData.current.dispatchData}
                                                // setDispatchData={setDispatchData}
                                            ></PdtItemDispatch>
                                            
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>

                    </Dialog>

                    <button className="btn btn-primary" type="button"
                        onClick={evt=>{
                            const warehouseId = evt.target.getAttribute('data-wid');
                            setWarehouseId(warehouseId);
                            openDialog({
                                fnOnOpenOnce:_=>{
                                    const warehouseName = (((rcdsWarehouse||{}).rcdsById||{})[warehouseId] || {}).name;
                                    setDlgTitle(`Dispatch Order`)

                                    setBtns([
                                        'cancel',
                                        ({})=>{
                                            return <RequestDeliver></RequestDeliver>
                                        }
                                    ]);                                            
                                },
                                fnOnCloseOnce:_=>{
                                    setRcdActive&&setRcdActive();
                                }}
                            )
                        }}
                    >
                        dispatch
                    </button>

                    {false&&<div className="dropdown">
                        <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            dispatch
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            {((rcdsWarehouse||{}).rcds||[]).map(warehouseDef=><li
                                key={Math.random()}
                            ><a className="dropdown-item" href="#"
                            
                                data-wid={warehouseDef.__id}
                                onClick={evt=>{
                                    const warehouseId = evt.target.getAttribute('data-wid');
                                    setWarehouseId(warehouseId);
                                    openDialog({
                                        fnOnOpenOnce:_=>{
                                            const warehouseName = (((rcdsWarehouse||{}).rcdsById||{})[warehouseId] || {}).name;
                                            setDlgTitle(`Dispatch to ( ${warehouseName} )`)

                                            setBtns([
                                                'cancel',
                                                ({})=>{
                                                    return <button type="button"
                                                        className="btn btn-primary"
                                                        onClick={evt=>{
                                                            console.log('dispatchData:', refData.current.dispatchData);
                                                            // [] generate 
                                                        }}
                                                    >deliver from <span className="fw-bolder text-warning">( {warehouseName} )</span></button>
                                                }
                                            ]);                                            
                                        },
                                        fnOnCloseOnce:_=>{
                                            setRcdActive&&setRcdActive();
                                        }}
                                    )
                                }}
                            
                            >{warehouseDef.name}</a></li>)}
                        </ul>
                    </div>}
                </DefaultResponse>
            },
            deliver: ((['deliver']).indexOf(activeNode)>=0)&&function Deliver({rcdId, setRcdActive, rcd}){
                const {regUse, DefaultResponse} = regUses();
                const {Dialog: DlgDeliver, openDialog: openDlgDeliver, closeDialog: closeDlgDeliver} = useDialog({
                    dlgTitle: 'deliver'
                });
                return <DefaultResponse>
                    <DlgDeliver></DlgDeliver>
                    <button type="button"
                        className="btn btn-primary"
                        onClick={evt=>{
                            openDlgDeliver({
                                fnOnCloseOnce: _=>{
                                    setRcdActive&&setRcdActive();
                                }
                            });
                        }}
                    >deliver</button>
                </DefaultResponse>
            },
            summaryOrder: function SummeryOrder({rcdId, setRcdActive}){
                return  <button type="button"
                    className="btn btn-sm btn-sm btn-primary"
                    onClick={evt=>{
                        setRcdActive&&setRcdActive();
                    }}
                >status</button>
            }
        },
        editDlg,
    }));


    const mainForm = (formsEditOrderDlg.mainForm||{}).form;
    refData.current.curForm = mainForm;
    if(mainForm){
        const form = mainForm;
        {
            if(!form._ww_org_setvalue){
                form._ww_org_setvalue = form.setValue;
                form._ww_setvalue_cb_pool = [];
                form.setValue = function(fldName, fldValue){
                    const fnPool = form._ww_setvalue_cb_pool || [];
                    fnPool.forEach(fn=>fn({fldName, fldValue, form}));
                    return form._ww_org_setvalue(...arguments);
                }
            }

            form._ww_setvalue_cb_pool.push(({fldName:fldNameIn, fldValue:fldValueIn, form})=>{
                if((['buyer', 'buyer_billing'].indexOf(fldNameIn)) >=0 && (fldValueIn == 0)){
                    form.setValue(fldNameIn+'_address1','');
                    form.setValue(fldNameIn+'_address2','');
                    form.setValue(fldNameIn+'_city','');
                    form.setValue(fldNameIn+'_province','');
                    form.setValue(fldNameIn+'_country','');
                    form.setValue(fldNameIn+'_zip','');
                }
            })            
        }


        // console.log('formsEditOrderDlg:', formsEditOrderDlg);
        mainForm.__on_wgt_change = async (fldName, form)=>{
            if(['buyer', 'buyer_billing'].indexOf(fldName) >=0 ){

                const r = await getRcds('addresses', {
                    page:0,
                    rcdsPerPage: 9999999999,
                    // timestamp: (curData||{}).timestamp,
                    filters: {
                        __filterFlds: {
                            entity: `^${form.getValues()[fldName]}$`
                        }
                    }
                });
                const rcdsAdress = ((r||{}).rcds||[]);
                if (rcdsAdress.length > 1){
                    const addrFlds = ['_address1','_address2','_city','_province','_country','_zip'];
                    // [] put address in cur values
                    setCurValues({...mainForm&&mainForm.getValues(),...(addrFlds=>{
                        const out = {};
                        addrFlds.forEach(addrfldName=>out[fldName+addrfldName] = '');
                        return out;
                    })(addrFlds)});

                    const rcdAdress = {};
                    fillAddress(form, fldName, {}, true);

                    const data = refData.current;
                    data.SelectAddress_tgtEntityFld = fldName;
                    data.SelectAddress_addressesPool = rcdsAdress;

                    openSelectAddressDlg();
                }else{
                    fillAddress(form, fldName, rcdsAdress[0] || {}, true);
                }
            }
        };
    }

    const {Dialog:SelectAddressDlg, openDialog:openSelectAddressDlg, closeDialog:closeSelectAddressDlg} = useDialog({
            dlgTitle: 'select address'
    });

    // const {data:rcdsOrder} = regUse(useOrdersOfStatus({
    //     type: activeNode
    // }));

    // const [addressPool, setAddressPool] = useState([]);
    const SelectAddress = ({})=>{
        const data = refData.current;
        const tgtEntityFld = data.SelectAddress_tgtEntityFld;
        const addresses = data.SelectAddress_addressesPool || [];
        return <div
            className="d-flex flex-column"
            onClick={evt=>{
                const idxAddr = evt.target.getAttribute('address');
                if(idxAddr!==undefined){
                    fillAddress(refData.current.curForm, tgtEntityFld, addresses[idxAddr]);
                    
                    closeSelectAddressDlg();
                }
            }}
        >{(addresses||[]).map((rcdAddress, idxAddr)=>{
            return <button 
                key={`${rcdAddress}-${idxAddr}`}
                className="btn btn-primary m-1"
                type="button" address={idxAddr}
            >[ {rcdAddress.name} ] {[
                rcdAddress.address1,
                rcdAddress.address2,
                rcdAddress.city,
                rcdAddress.province,
                rcdAddress.country,
                rcdAddress.zip
            ].filter(a=>a).join(',   ')}</button>;
        })}</div>
    };

    return <DefaultResponse>
        <EditOrderDialog></EditOrderDialog>
        <SelectAddressDlg>
            <SelectAddress></SelectAddress>
        </SelectAddressDlg>
        <div className="container">
            <h1>Sales Order Process</h1>
            {/* <div>{activeNode}</div> */}
            <SalesOrderPhaseSelector
                activeNode = {activeNode}
                setActiveNode = {setActiveNode}
                resetPage = {resetPage}

                openEditOrderDialog = {openEditOrderDialog}
                setOrderRcdId = {setOrderRcdId}
                setOrderRcdDefault={setOrderRcdDefault}
            ></SalesOrderPhaseSelector>
            {(['deliver'].indexOf(activeNode)>=0)&&<WarehouseSelector></WarehouseSelector>}
            
            <SalesOrdersList></SalesOrdersList>
            {/* <span>orders count: {(rcdsOrder||{}).rcdCnt}</span>
            <div>
                {((rcdsOrder||{}).rcds||[]).map(rcd=><div
                    key={rcd.__id}
                >{rcd.__id}</div>)}
            </div> */}

        </div>
    </DefaultResponse>
}